import PropTypes from 'prop-types';
import { createContext, useState, useEffect } from 'react';
// hooks
import useResponsive from '../hooks/useResponsive';
import { safeLocalStorage } from '../utils/safeStorage';

// ----------------------------------------------------------------------

const initialState = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {},
  onHoverEnter: () => {},
  onHoverLeave: () => {}
};

const CollapseDrawerContext = createContext(initialState);

// ----------------------------------------------------------------------

CollapseDrawerProvider.propTypes = {
  children: PropTypes.node
};

function CollapseDrawerProvider({ children }) {
  const isDesktop = useResponsive('up', 'lg');
  let settings = null;
  try {
    settings = JSON.parse(safeLocalStorage.getItem('settings'));
  } catch {
    settings = null;
  }
  const [collapse, setCollapse] = useState({
    click: false,
    hover: false
  });

  useEffect(() => {
    if (!isDesktop) {
      const isCollapse = settings?.viewNavbar
        ? {
            click: true,
            hover: false
          }
        : {
            click: false,
            hover: false
          };
      setCollapse(isCollapse);
    }
  }, [isDesktop, settings?.viewNavbar]);

  const handleToggleCollapse = () => {
    setCollapse({ ...collapse, click: !collapse.click });
    safeLocalStorage.setItem(
      'settings',
      JSON.stringify({ ...settings, viewNavbar: !collapse.click })
    );
  };

  const handleHoverEnter = () => {
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: collapse.click && !collapse.hover,
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
